const x = {
  pixelwidth: 300,
  header: "Parkscheinautomat",
  navigator: {
    noun: {
      singular: "Parkscheinautomat",
      plural: "Parkscheinautomaten",
    },
  },
  displaySecondaryInfoAction: false,
  noCurrentFeatureTitle: "Keine Parkscheinautomaten gefunden",
  noCurrentFeatureContent: "",
};
export default x;
